import Script from 'next/script';

type AwsRumProps = {
  rumAppId: string;
  rumGuestRoleArn: string;
  rumIdentityPoolId: string;
};

export default function AwsRumScript(props: AwsRumProps) {
  const { rumAppId, rumGuestRoleArn, rumIdentityPoolId } = props;

  return (
    <Script
      id="aws-rum-script"
      defer
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
        (function(n,i,v,r,s,c,x,z){x=window.AwsRumClient={q:[],n:n,i:i,v:v,r:r,c:c};window[n]=function(c,p){x.q.push({c:c,p:p});};z=document.createElement('script');z.async=true;z.src=s;document.head.insertBefore(z,document.head.getElementsByTagName('script')[0]);})(
          'cwr',
          '${rumAppId}',
          '1.0.0',
          'us-east-2',
          'https://client.rum.us-east-1.amazonaws.com/1.2.1/cwr.js',
          {
            sessionSampleRate: 1,
            guestRoleArn: "${rumGuestRoleArn}",
            identityPoolId: "${rumIdentityPoolId}",
            endpoint: "https://dataplane.rum.us-east-2.amazonaws.com",
            telemetries: ["performance","errors","http"],
            allowCookies: true,
            enableXRay: false
          }
        );
      `,
      }}
    />
  );
}
